( function () {
	'use strict';

	function evidenceService ( apiService, saveFileAs, FILETYPES, _ ) {
		function searchEvidence ( evidencesArr, action, evidence ) {
			var oldEvidence = _.findWhere( evidencesArr, { 'id' : evidence.id } );

			if ( oldEvidence ) {
				if ( action === 'edit' ) {
					evidencesArr[ evidencesArr.indexOf( oldEvidence ) ] = evidence;
				} else {
					evidencesArr.splice( evidencesArr.indexOf( oldEvidence ), 1 );
				}
			}
		}

		function editDeleteEvidence ( evidence, action, obsData ) {
			// search and change in masterEvidences
			searchEvidence( obsData.masterEvidences, action, evidence );

			// search and change in masterEvidences
			searchEvidence( obsData.evidences, action, evidence );

			// search and change in group level
			angular.forEach( obsData.template.groups, function ( group ) {
				searchEvidence( group.evidences, action, evidence );

				// search in indicator level
				angular.forEach( group.indicators, function ( indicator ) {
					searchEvidence( indicator.evidences, action, evidence );
				} );
			} );
		}

		return {
			'editDeleteEvidence' : editDeleteEvidence
		};
	}

	angular
		.module( 'app.components' )
		.factory( 'evidenceService', evidenceService );
} )( );
